module.exports = __webpack_public_path__ + "game.svg?05b7d0def1f28c9e11fc4734a4c3f061";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/game.svg
// module id = 116
// module chunks = 0